export default __webpack_public_path__ + "static/media/member.2f159932.png";